namespace RioERP.Masters {
    export interface Rioplay8AllowedDevicesRow {
        Id?: string;
        Device?: string;
    }

    export namespace Rioplay8AllowedDevicesRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Id';
        export const localTextPrefix = 'Masters.Rioplay8AllowedDevices';
        export const lookupKey = 'Masters.Rioplay8AllowedDevices';

        export function getLookup(): Q.Lookup<Rioplay8AllowedDevicesRow> {
            return Q.getLookup<Rioplay8AllowedDevicesRow>('Masters.Rioplay8AllowedDevices');
        }
        export const deletePermission = 'Masters:MastersManagement:Modify';
        export const insertPermission = 'Masters:MastersManagement:Modify';
        export const readPermission = 'Masters:MastersManagement:View';
        export const updatePermission = 'Masters:MastersManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            Device = "Device"
        }
    }
}
